import React from 'react';
import { Calendar, Bed, Utensils, Ship, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { featuredPackage } from '../data/mock';
import WhatsAppCTA from './WhatsAppCTA';

const FeaturedPackage = () => {
  const handleCheckAvailability = () => {
    const message = encodeURIComponent(`Hi! I'm interested in the ${featuredPackage.title}. Can you share availability?`);
    window.open(`https://wa.me/918591732501?text=${message}`, '_blank');
  };

  return (
    <section id="featured-package" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <Badge className="bg-[#c9a961]/10 text-[#c9a961] border-[#c9a961]/20 px-4 py-2 text-sm font-semibold mb-4 animate-fade-in-up">
            FEATURED PACKAGE
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f] mb-4 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            {featuredPackage.title}
          </h2>
        </div>

        <Card className="overflow-hidden border-none shadow-2xl max-w-5xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <div className="grid md:grid-cols-2 gap-0">
            {/* Image Section */}
            <div className="relative h-96 md:h-auto overflow-hidden">
              <img 
                src={featuredPackage.image}
                alt={featuredPackage.title}
                className="w-full h-full object-cover hover:scale-110 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute top-6 right-6 bg-[#c9a961] text-white px-6 py-3 rounded-lg shadow-lg">
                <div className="text-sm font-medium">Starting from</div>
                <div className="text-3xl font-bold">{featuredPackage.price}</div>
                <div className="text-sm">{featuredPackage.priceNote}</div>
              </div>
            </div>

            {/* Content Section */}
            <CardContent className="p-8 md:p-12 flex flex-col justify-center">
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#c9a961]/10 rounded-lg flex items-center justify-center">
                    <Calendar className="text-[#c9a961]" size={24} />
                  </div>
                  <div>
                    <div className="font-semibold text-[#1e3a5f] text-lg">Duration</div>
                    <div className="text-gray-600">{featuredPackage.duration}</div>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#c9a961]/10 rounded-lg flex items-center justify-center">
                    <Bed className="text-[#c9a961]" size={24} />
                  </div>
                  <div>
                    <div className="font-semibold text-[#1e3a5f] text-lg">Accommodation</div>
                    <div className="text-gray-600">{featuredPackage.accommodation}</div>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#c9a961]/10 rounded-lg flex items-center justify-center">
                    <Utensils className="text-[#c9a961]" size={24} />
                  </div>
                  <div>
                    <div className="font-semibold text-[#1e3a5f] text-lg">Meals</div>
                    <div className="text-gray-600">{featuredPackage.meals}</div>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#c9a961]/10 rounded-lg flex items-center justify-center">
                    <Ship className="text-[#c9a961]" size={24} />
                  </div>
                  <div>
                    <div className="font-semibold text-[#1e3a5f] text-lg">Transfers</div>
                    <div className="text-gray-600">{featuredPackage.transfers}</div>
                  </div>
                </div>

                <Button 
                  onClick={handleCheckAvailability}
                  size="lg"
                  className="w-full bg-[#B8964F] hover:bg-[#a67f3a] text-white text-lg py-7 mt-6 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 group"
                >
                  {featuredPackage.ctaText}
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" size={20} />
                </Button>
              </div>
            </CardContent>
          </div>
        </Card>

        <WhatsAppCTA message="Hi! I'd like to inquire about the Maldives package." />
      </div>
    </section>
  );
};

export default FeaturedPackage;
